module.exports = {
  PLUGIN_NAME: 'sentry',
  BLAZE_SENTRY_ENVIRONMENT: 'production',
  BLAZE_SENTRY_ATTACH_STRACKTRACE: true,
  BLAZE_SENTRY_IGNORE_ERROR_TYPES: 'PersistedQueryNotFoundError'
};
